import React from 'react';
import PropTypes from 'prop-types';
import Images from '../../assets/Images';

import Timer from '../Timer';

import styles from './TestHeader.module.scss';

class TestHeader extends React.Component {
  render() {
    const { 
      section, 
      updateTime, 
      timeSaved, 
      completeSection,
      showTimer } = this.props;
    
    return (
      <div className={styles.header}>
        <div className={styles.logo}>
          <img src={Images.logo} alt='sly logo'></img>
        </div>
        <div className={styles.headerBody}>
          <div className={styles.title}>
            <div className={styles.title1}>{section.displayName}</div>
            <div className={styles.title2}>
            {section.questionCount} questions - {Math.floor(section.time/60)} minutes
            </div>
          </div>
          <div className={styles.timer}>
            { showTimer ?
              <Timer
                key={section.subject}
                timeSaved={timeSaved}
                onTimerComplete={completeSection}
                timeInSeconds={section.time}
                notifyParent={updateTime}
              />: null}
          </div>
        </div>
            
      </div>
    );
  }
}

TestHeader.propTypes = {
  section: PropTypes.object.isRequired,
  pauseSession: PropTypes.func,
  completeSection: PropTypes.func,
  updateTime: PropTypes.func,
  timeSaved: PropTypes.number,
  showTimer: PropTypes.bool.isRequired,
  isDesktop: PropTypes.bool
};

TestHeader.defaultProps = {
  showTimer: true,
};
export default TestHeader;